// DateFilters.jsx
import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import {
  quartersList,
  quarterToMonths,
  form24QFields,
  checkCurrentFinancialYear,
  formatFinancialYears,
  getPreviousMonthAndFY,
  isDataSentToCA,
  isDataReviewByCA,
} from "../../utils/client/misc";
import { apiPost } from "../../service/admin/apiService";

const DateFilters = ({
  selectedYear,
  setSelectedYear,
  selectedQuarter,
  setSelectedQuarter,
  selectedMonth,
  setSelectedMonth,
  getFormInfo,
  setSelectedFYearId,
  setFormInfo,
  setFormFinancialYear,
  showMonth = true,
}) => {
  const [quarters, setQuarters] = useState([]);
  const [financialYear, setFinancialYear] = useState([]);
  const [filteredMonths, setFilteredMonths] = useState([]);
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));
  const tk = localStorage.getItem("tk") || "";

  useEffect(() => {
    getFinancialYear();
  }, []);

  useEffect(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    let currentQuarterIndex = -1;

    if (currentMonth >= 3 && currentMonth <= 5) currentQuarterIndex = 0;
    else if (currentMonth >= 6 && currentMonth <= 8) currentQuarterIndex = 1;
    else if (currentMonth >= 9 && currentMonth <= 11) currentQuarterIndex = 2;
    else currentQuarterIndex = 3;

    if (selectedYear === checkCurrentFinancialYear()) {
      setQuarters(quartersList.slice(0, currentQuarterIndex + 1));
    } else if (selectedYear) {
      setQuarters([...quartersList]);
    } else {
      setQuarters([]);
    }
    setSelectedQuarter("");
  }, [selectedYear]);

  useEffect(() => {
    if (selectedQuarter && quarterToMonths[selectedQuarter]) {
      setFilteredMonths(quarterToMonths[selectedQuarter]);
      setSelectedMonth("");
    } else {
      setFilteredMonths([]);
    }
  }, [selectedQuarter]);

  useEffect(() => {
    console.log("selectedMonth", selectedMonth);
    if (selectedMonth !== "") {
      getFormInfo();
    }
  }, [selectedMonth]);

  const getFinancialYear = async () => {
    try {
      const payload = {
        action: "getfinancialyearlist",
        to: clientInfo ? clientInfo?.tk : tk,
      };
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      if (Number(response?.errordetails?.errorcode) > 0) {
      } else if (response?.responsedetails) {
        const fy = await formatFinancialYears(response?.responsedetails);
        setTimeout(() => {
          setFinancialYear(fy);
          setFormFinancialYear(fy);
        }, 300);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const setSelectedFinancialYear = (value) => {
    const fyId = financialYear.find((el) => el.value === value).id;
    if (fyId > 0) {
      setSelectedFYearId(fyId);
    }
    setFormInfo([]);
  };

  return (
    <Form className="mb-3 p-3 rounded" style={{ backgroundColor: "#e4e274" }}>
      <Row>
        <Col md={showMonth ? 4 : 6}>
          <Form.Group controlId="financialYear">
            <Form.Label className="textbox-label">Financial Year</Form.Label>
            <Form.Select
              style={{ fontSize: "13px" }}
              value={selectedYear}
              onChange={(e) => {
                setSelectedYear(e.target.value);
                setSelectedFinancialYear(e.target.value);
              }}
            >
              {financialYear.map((year, index) => (
                <option key={index} value={year.value}>
                  {year.value}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={showMonth ? 4 : 6}>
          <Form.Group controlId="quarter">
            <Form.Label className="textbox-label">Quarter</Form.Label>
            <Form.Select
              style={{ fontSize: "13px" }}
              value={selectedQuarter}
              onChange={(e) => setSelectedQuarter(e.target.value)}
            >
              <option value="noQuarter"></option>
              {quarters.map((qtr, index) => (
                <option key={index} value={qtr} disabled={qtr === ""}>
                  {qtr}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {showMonth ? (
          <Col md={4}>
            <Form.Group controlId="month">
              <Form.Label className="textbox-label">Month</Form.Label>
              <Form.Select
                style={{ fontSize: "13px" }}
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                <option value="noMonth"></option>
                {filteredMonths.map((m, i) => (
                  <option key={i} value={m}>
                    {m}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        ) : null}
      </Row>
    </Form>
  );
};

export default DateFilters;
